<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icon_liangbiao">
      <rect y="0.5" width="24" height="24" rx="4" fill="#30C6CB" />
      <path id="Vector"
        d="M16.5092 13.5114C16.5092 13.3327 16.3643 13.1878 16.1856 13.1878H13.1895C13.0108 13.1878 12.8659 13.3327 12.8659 13.5114V14.4112C12.8659 14.5899 12.7211 14.7348 12.5424 14.7348H5.20441C5.02572 14.7348 4.88086 14.8796 4.88086 15.0583V16.4738C4.88086 16.6525 5.02572 16.7974 5.20441 16.7974H12.5424C12.7211 16.7974 12.8659 16.9422 12.8659 17.1209V17.6773C12.8659 17.856 13.0108 18.0009 13.1895 18.0009H16.1866C16.3653 18.0009 16.5102 17.856 16.5102 17.6773V17.1209C16.5102 16.9422 16.655 16.7974 16.8337 16.7974H18.7937C18.9724 16.7974 19.1173 16.6525 19.1173 16.4738V15.0583C19.1173 14.8796 18.9724 14.7348 18.7937 14.7348H16.8327C16.654 14.7348 16.5092 14.5899 16.5092 14.4112V13.5114ZM15.4925 16.6462C15.4924 16.8248 15.3476 16.9696 15.1689 16.9696H14.2063C14.0276 16.9696 13.8827 16.8247 13.8827 16.646V14.5427C13.8827 14.364 14.0276 14.2191 14.2063 14.2191H15.1697C15.3484 14.2191 15.4933 14.364 15.4933 14.5428L15.4925 16.6462ZM11.4568 8.54695C11.2781 8.54695 11.1333 8.40209 11.1333 8.2234V7.32356C11.1333 7.14486 10.9884 7 10.8097 7H7.81255C7.63385 7 7.48899 7.14486 7.48899 7.32356V8.2234C7.48899 8.40209 7.34413 8.54695 7.16544 8.54695H5.20543C5.02674 8.54695 4.88188 8.69181 4.88188 8.87051V10.286C4.88188 10.4647 5.02674 10.6096 5.20543 10.6096H7.16544C7.34413 10.6096 7.48899 10.7544 7.48899 10.9331V11.4895C7.48899 11.6682 7.63385 11.8131 7.81255 11.8131H10.8097C10.9884 11.8131 11.1333 11.6682 11.1333 11.4895V10.9331C11.1333 10.7544 11.2781 10.6096 11.4568 10.6096H18.7927C18.9714 10.6096 19.1163 10.4647 19.1163 10.286V8.87051C19.1163 8.69181 18.9714 8.54695 18.7927 8.54695H11.4568ZM10.1164 10.4582C10.1164 10.6369 9.97159 10.7818 9.79289 10.7818H8.82936C8.65067 10.7818 8.50581 10.6369 8.50581 10.4582V8.35486C8.50581 8.17616 8.65067 8.0313 8.82936 8.0313H9.79289C9.97159 8.0313 10.1164 8.17616 10.1164 8.35486V10.4582Z"
        fill="white" />
    </g>
  </svg>

</template>
<script>
export default {
  name: 'survey-table',
  props: {
    width: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
      }
    }
  }
}
</script>